import { combineReducers } from '@reduxjs/toolkit';

import account from './account';
import cookbook from './cookbook';
import dashboard from './dashboard';
import dismissals from './dismissals';
import grace from './grace';
import homepage from './homepage';
import mealFilters from './mealFilters';
import meals from './meals';
import menuSearch from './menuSearch';
import messageCenter from './messageCenter';
import messages from './messages';
import promotions from './promotions';
import recommendedMeals from './recommendedMeals';
import restartCampaign from './restartCampaign';
import sendABox from './sendABox';
import shoppingList from './shoppingList';
import user, * as fromUser from './user';
import userOffers from './userOffers';
import v3Dashboard from './v3/dashboard';
import v3User, * as fromV3User from './v3/user';

export default combineReducers({
  account,
  cookbook,
  dashboard,
  dismissals,
  grace,
  homepage,
  mealFilters,
  meals,
  messages,
  messageCenter,
  recommendedMeals,
  shoppingList,
  user,
  userOffers,
  promotions,
  restartCampaign,
  menuSearch,
  sendABox,
  v3: combineReducers({
    dashboard: v3Dashboard,
    user: v3User,
  }),
});

export const selectUser = state => state.user;
export const selectUserLoadingStatus = state => fromUser.selectUserStatus(selectUser(state));
export const selectMealAddonSelections = state =>
  fromUser.selectMealAddonSelections(selectUser(state));
export const selectOptInSelections = state => fromUser.selectOptInSelections(selectUser(state));
export const selectExperimentAssignment = (state, experimentName) =>
  fromUser.selectExperimentAssignment(selectUser(state), experimentName);
export const selectUserInviteCode = state => fromUser.selectUserInviteCode(selectUser(state));
export const selectUserAddresses = state => fromUser.selectUserAddresses(selectUser(state));
export const selectCurrentMenuSlug = state => fromUser.selectCurrentMenuSlug(selectUser(state));

export const selectUserV3 = state => state.v3.user;
export const selectUserLoadingStatusV3 = state => fromV3User.selectUserStatus(selectUserV3(state));
export const selectMealAddonSelectionsV3 = state =>
  fromV3User.selectMealAddonSelections(selectUserV3(state));
export const selectOptInSelectionsV3 = state =>
  fromV3User.selectOptInSelections(selectUserV3(state));
export const selectExperimentAssignmentV3 = (state, experimentName) =>
  fromV3User.selectExperimentAssignment(selectUserV3(state), experimentName);
export const selectUserInviteCodeV3 = state => fromV3User.selectUserInviteCode(selectUserV3(state));
export const selectUserAddressesV3 = state => fromV3User.selectUserAddresses(selectUserV3(state));
export const selectCurrentMenuSlugV3 = state =>
  fromV3User.selectCurrentMenuSlug(selectUserV3(state));
